import { type ChipProps, Chip as MUI_Chip } from '@mui/material'

export const Chip = (props: ChipProps) => {
  return <MUI_Chip {...props} />
}
